import context from '../context/context.js';
import IsSupported from './is-supported.js';
import { isSamsungDevice } from './get-os.js';

/** @typedef {import('synapse-common-device-service').Device} Device */
/** @typedef {import('../types/adapted-device').ConnectableFlags} ConnectableFlags */

/**
 *
 * @param {Device} device
 * @returns boolean
 */
const isMobile = device => device.platform === 'Android';

/**
 *
 * @param {Device} device
 * @returns boolean
 */
const isActive = device => device.status && device.status !== 'Offline' && device.verified;

/**
 *
 * @param {Device} device
 * @returns {boolean}
 */
const isTerminalAllowed = device => IsSupported.canTerminal(device.osName, device.clientVersion);

/**
 *
 * @param {Device} device
 * @returns {boolean}
 */
const isUserPresent = device => !device?.locked;

const hasUnattendedCapability = () => context.state?.user?.capabilities?.includes('mdua');

const hasAttendedCapability = () => context.state?.user?.capabilities?.includes('mdat');

const isRemoteCapabilityMissing = device =>
  (!isUserPresent(device) && !hasUnattendedCapability()) || (isUserPresent(device) && !hasAttendedCapability());

const getRemoteTooltipType = device => {
  if (isUserPresent(device) && !hasAttendedCapability() && hasUnattendedCapability()) {
    return 'noAttendedRemote';
  }

  if (!isUserPresent(device) && hasAttendedCapability() && !hasUnattendedCapability()) {
    return 'noUnattendedRemote';
  }

  if (!hasAttendedCapability() && !hasUnattendedCapability()) {
    return 'noCapabilityRemote';
  }

  if (device.status === 'Offline') {
    return 'offlineRemote';
  }

  if (isSamsungDevice(device)) {
    return 'samsungRemote';
  }

  return null;
};

/**
 *
 * @param {Device} device
 * @returns {ConnectableFlags}
 * */
export default device => ({
  remote: isActive(device) && context.state?.user?.verified && !isRemoteCapabilityMissing(device),
  remoteTooltipType: getRemoteTooltipType(device),
  quickView: isActive(device) && !isMobile(device),
  fileManager: isActive(device) && !!IsSupported.canFileManager,
  terminal: isActive(device) && isTerminalAllowed(device),
});
